import React from 'react'
import GameBoardStandardSudoku from '../Components/GameBoardStandardSudoku'


export default function PuzzleScreen() {
  return (
        <GameBoardStandardSudoku/>
  )
}
